import styles from "../styles/PrivacyPolicy.module.css";

export default function PrivacyPolicy() {
  return (
    <article className={styles.policy} aria-label="Privacy Policy">
      <p className={styles.updated}>Last updated: 01.02.2026</p>

      <h2 className={styles.h2}>Privacy Policy</h2>

      <section className={styles.section}>
        <h3 className={styles.h3}>1. Data Controller</h3>

        <div className={styles.card}>
          <p className={styles.cardTitle}>
            The controller of personal data is:
          </p>
          <p className={styles.cardLine}>
            <strong>Krzysztof M. Chabowski</strong> (sole proprietorship)
          </p>
          <p className={styles.cardLine}>
            Address: ul. Tadeusza Szafrana 5C/57, 30-363 Kraków, Poland
          </p>
          <p className={styles.cardLine}>VAT ID (NIP): 8571881386</p>
          <p className={styles.cardLine}>REGON: 387105503</p>
          <p className={styles.cardLine}>
            Email:{" "}
            <a
              className={styles.link}
              href="mailto:krzysztof.m.chabowski@gmail.com"
            >
              krzysztof.m.chabowski@gmail.com
            </a>
          </p>
        </div>

        <p className={styles.p}>
          The controller processes personal data in accordance with applicable
          law, including Regulation (EU) 2016/679 (GDPR).
        </p>
      </section>

      <section className={styles.section}>
        <h3 className={styles.h3}>2. Scope of processed data</h3>
        <p className={styles.p}>
          The website may process the following personal data:
        </p>
        <ul className={styles.list}>
          <li>Name</li>
          <li>Email address</li>
          <li>Message content submitted via the contact form</li>
          <li>IP address (for technical and security purposes)</li>
        </ul>
        <p className={styles.p}>
          Providing data is voluntary but necessary to respond to inquiries.
        </p>
      </section>

      <section className={styles.section}>
        <h3 className={styles.h3}>3. Purpose and legal basis of processing</h3>
        <p className={styles.p}>
          Personal data is processed for the purpose of:
        </p>
        <ul className={styles.list}>
          <li>Responding to inquiries submitted via the contact form</li>
          <li>
            Conducting correspondence related to the controller’s business
            activity
          </li>
        </ul>

        <p className={styles.p}>The legal basis for processing is:</p>
        <ul className={styles.list}>
          <li>
            Article 6(1)(b) GDPR – steps taken at the request of the data
            subject prior to entering into a contract
          </li>
          <li>
            Article 6(1)(f) GDPR – the legitimate interest of the controller in
            handling correspondence
          </li>
        </ul>
      </section>

      <section className={styles.section}>
        <h3 className={styles.h3}>4. Data retention period</h3>
        <p className={styles.p}>
          Personal data is stored only for as long as necessary to:
        </p>
        <ul className={styles.list}>
          <li>Respond to the inquiry</li>
          <li>Continue correspondence if required</li>
        </ul>
        <p className={styles.p}>
          After communication is completed, the data may be deleted and is not
          used for other purposes.
        </p>
      </section>

      <section className={styles.section}>
        <h3 className={styles.h3}>5. Data recipients</h3>
        <p className={styles.p}>
          Personal data is not shared with third parties, except for:
        </p>
        <ul className={styles.list}>
          <li>
            Hosting and email service providers, solely to the extent necessary
            for the operation of the website and email communication
          </li>
        </ul>
        <p className={styles.p}>
          Data is not transferred outside the European Union.
        </p>
      </section>

      <section className={styles.section}>
        <h3 className={styles.h3}>6. Rights of the data subject</h3>
        <p className={styles.p}>Data subjects have the right to:</p>
        <ul className={styles.list}>
          <li>Access their personal data</li>
          <li>Rectify their data</li>
          <li>Request erasure of data</li>
          <li>Restrict processing</li>
          <li>Object to processing</li>
          <li>Lodge a complaint with the supervisory authority</li>
        </ul>
        <p className={styles.p}>
          To exercise these rights, please contact the controller via email.
        </p>
      </section>

      <section className={styles.section}>
        <h3 className={styles.h3}>7. Cookies</h3>
        <p className={styles.p}>
          The website does not use cookies for analytics or marketing purposes.
          Only technical cookies necessary for proper operation of the website
          may be used.
        </p>
      </section>

      <section className={styles.section}>
        <h3 className={styles.h3}>8. Data security</h3>
        <p className={styles.p}>
          Appropriate technical and organizational measures are applied to
          protect personal data against loss, unauthorized access, or
          disclosure.
        </p>
      </section>

      <section className={styles.section}>
        <h3 className={styles.h3}>9. Changes to this Privacy Policy</h3>
        <p className={styles.p}>
          This Privacy Policy may be updated if the website functionality or
          legal requirements change.
        </p>
      </section>
    </article>
  );
}
